import { Component, EventEmitter, Input, OnDestroy, OnInit, ViewChild, Output, SimpleChanges, NgZone } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import * as Excel from "exceljs";
import { Subject, takeUntil } from "rxjs";
import { FileUpload } from "primeng/fileupload";

import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ImportserialService } from '../../services/importserial.service';
import { utils as XLSXUtils, read } from "xlsx";

interface IExportAsExcelProps {
  readonly fileName: string;
  readonly sheetName?: string;
  readonly header?: string[];
}

@Component({
  selector: 'app-shared-import-series',
  templateUrl: './import-series.component.html',
  styleUrls: ['./import-series.component.scss']
})
export class ImportSeriesComponent implements OnInit, OnDestroy {

  @Input() display;
  @Input() disabledSave: boolean = true;
  @Input() trackingJSON;
  @Input() importCount: number = 0;
  @Input() serialTypeId: number = 0;
  @Input() importForAllProducts: boolean = false;
  @Input() showWarehouse: boolean = false;
  @Input() serialOnly: boolean = true;
  @Input() importCols = [];
  @Input() savedData = [];
  @Input() fromPO: boolean = false;
  @Input() fromOrder: boolean = false;
  @Input() hideBulkScan: boolean = false;
  @Input() productList = [];
  @Input() trackingOptions = [];
  @Input() warehouseList = [];
  @Input() warehouseId: number = 0;
  @Input() rpoList = [];
  @ViewChild('fileInput') fileInput: FileUpload;
  @Output() cancelClicked = new EventEmitter();
  @Output() onSave = new EventEmitter();
  @Output() onRevertSuccess = new EventEmitter();
  message: string = '';
  batchList = [];
  batchGroup: any = null;
  isDisabled: boolean = false;
  displayBatchForm: boolean = false;
  selectedBatch = null;
  activeIndex: number = 0;
  selectedRPO;
  selectedLocation = null;
  date: Date | null = null;
  maxDate: Date;
  formattedDate: string | null = null;
  buttonDisabled: boolean = false;
  actions: Array<any> = [
    {
      name: 'Add',
      value: 'add'
    }
   
  ];
  excelFileData = [];
  selectedAction = this.actions[0];
  uploadedFiles = [];
  files = [];
  selectedFile: any = null;
  fields = [];
  allowedExtensions = [".xlsx"]; // For the attachment files
  referenceFields = [];
  selectedRefField = null;
  //scan
  @Input() systemTrackingData = [];
  @Input() serialConfig = null;
  @Input() creditMemoId: number = 0;
  @Output() onScan = new EventEmitter();
  rowsPerPageTB = [100, 200, 300, 500];
  pageSize: 100;
  totalTBRecord: number = 0;
  first: number = 0;
  nameLists = [];
  autoGenerateLists = [];
  trackingForm: FormGroup;
  listLength: number = 0;
  allChecked: boolean = false;
  displayFieldMapping: boolean = false;
  selectedFileHeaders: any = [];
  selectedModule: any = null;
  selectedChannel: any = null;
  disabledMapping: boolean = false;
  optionForm: FormGroup;
  selectAllOption: boolean = false;
  displayOptions: boolean = false;
  optionFields = [];

  protected ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(private messageService: MessageService, private confirmationService: ConfirmationService,
    private fb: FormBuilder, private serialService: ImportserialService, private ngZone: NgZone) { }

  ngOnInit(): void {
    this.maxDate = new Date();
    this.selectedRPO = null;
    this.selectedFile = null;
    if (this.hideBulkScan && !this.showWarehouse) {
      this.activeIndex = 1;
    } else {
      this.activeIndex = 0;
    }
    this.trackingForm = this.fb.group({
      itemNo: [null],
      productId: [0],
      lotNo: [null],
      revisionNO: [null],
      serialNo: ["", [Validators.pattern(/^[A-Za-z0-9-]*$/)]]
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.disabledSave?.currentValue) {
      this.isDisabled = this.disabledSave;
    }
    if (typeof (this.trackingJSON) == 'string') {
      this.trackingJSON = JSON.parse(this.trackingJSON)
    } else if (this.trackingJSON && typeof (this.trackingJSON) == 'object') {
      this.trackingJSON = this.trackingJSON;
    } else if (this.showWarehouse) {
      this.trackingJSON = {
        lotChecked: true, revisionChecked: true, serializedChecked: true, serial2Checked: true, serial3Checked: true,
        serial4Checked: true, serial5Checked: true, serial6Checked: true, serial7Checked: true, serial8Checked: true, serial9Checked: true, serial10Checked: true, serial11Checked: true, serial12Checked: true, serial13Checked: true,
        serial14Checked: true, serial15Checked: true, serial16Checked: true, serial17Checked: true, expirationChecked: true,
        field1: true, field2: true, field3: true, field4: true, field5: true, field6: true, field7: true, field8: true, field9: true,
        field10: true, field11: true, field12: true, field13: true, field14: true, field15: true, field16: true, field17: true, field18: true,
        field19: true, field20: true,
      };
    } else {
      this.trackingJSON = {
        lotChecked: true, revisionChecked: true, serializedChecked: true, serial2Checked: true, serial3Checked: true, serial4Checked: true, serial5Checked: true,
        serial6Checked: true, serial7Checked: true, serial8Checked: true, serial9Checked: true, serial10Checked: true, serial11Checked: true, serial12Checked: true, serial13Checked: true,
        serial14Checked: true, serial15Checked: true, serial16Checked: true, serial17Checked: true, expirationChecked: true
      };
    }
    this.rpoList = this.rpoList.map(data => ({
      ...data,
      customName: data.isBillCreated ? data.billNO : data.number
    }));
  
    if (changes.trackingOptions?.currentValue) {
      this.referenceFields = this.trackingOptions?.filter(({ enabled, code }) => enabled && this.trackingJSON[code]) || [];
    
      if(this.importForAllProducts || (this.serialOnly && this.showWarehouse)){
        this.referenceFields.push({ labelName: 'ItemNo', code: 'ItemNo', name: 'ItemNo' , field : 'ItemNo' });
      }
       if(!this.importForAllProducts && !this.showWarehouse){
        this.actions.push( {
          name: 'Add/Update',
          value: 'update'
        });
      }
    }
    if (!this.serialOnly) {
      this.getBatchGroup();
    }
  }

  getCellByHeader(headerName) {
    return this.selectedFileHeaders.some(header => header.moduleField?.label === headerName);
  }

  /**batches**/
  getBatchGroup() {
    this.serialService.getAllGroups().subscribe((groups) => {
      this.batchGroup = groups.find(group => group.name == 'Serial Batches');
      this.getSerialBatches(this.batchGroup?.id);
    })
  }

  getSerialBatches(groupId) {
    this.serialService.getAllGroupTypes(groupId).subscribe({
      next: (batch) => {
        // Check if batch is null, undefined, or empty (in case it's an array)
        if (batch?.length > 0) {
          this.batchList = batch;
        } else {
          this.batchList = [];
        }
        // Add the 'Add New Batch' option regardless
        this.batchList.push({ id: 0, name: 'Add New Batch' });
      },
      error: (err) => {
        // Optional: handle errors including 204 if server sends it as an error
        if (err.status === 204) {
          this.batchList = [{ id: 0, name: 'Add New Batch' }];
        } else {
          console.error('Error fetching group types:', err);
        }
      }
    });
  }

  onBatchChange() {
    if (this.selectedBatch?.name == 'Add New Batch') {
      this.displayBatchForm = true;
    }
  }

  onSaveBatch() {
    this.displayBatchForm = false;
    this.selectedBatch = null;
    this.getSerialBatches(this.batchGroup?.id);
  }

  closeBatchDialog() {
    this.displayBatchForm = false;
  }

  getImportCount() {
    this.importCount = 0;
    this.productList = [];
    for (let prd of this.selectedRPO?.receivedPurchaseOrderProducts) {
      for (let bundle of prd.receivedPurchaseBundleDetail) {
        if (bundle.subProduct?.isTrackingRequired) {
          this.importCount = this.importCount + bundle.quantity - bundle.serialCount;
          if (bundle.quantity > 0) {
            this.productList.push(bundle);
          }
        }
      }
      if (prd.product?.isTrackingRequired) {
        this.importCount = this.importCount + prd.quantity - prd.serialCount;
        if (prd.quantity > 0) {
          this.productList.push(prd);
        }
      }
    }
  }

  displayName(code, type) {
    if (type === 'label') {
      return this.trackingOptions?.find(opt => opt.enabled && opt.code == code)?.name;
    } else if (type == 'duplicate') {
      return this.trackingOptions?.find(opt => opt.code == code)?.allowDuplicate;
    } else {
      return this.trackingOptions?.find(opt => opt.code == code)?.formControlName;
    }
  }

  get disabledOptionDialog() {
    return !this.optionFields?.some(col => col.checked);
  }

  downloadFile() {
    if (this.selectedAction?.value == 'update' && this.savedData?.length) {
      this.optionFields = this.trackingOptions
        ?.filter(({ enabled, code }) => enabled && this.trackingJSON[code]) // Keep only enabled options
        .map(option => ({
          ...option, // Spread all original fields
          checked: false // Add new field with corresponding trackingJSON value
        })) || [];
      this.displayOptions = true;
    } else {
      this.prepopulateData();
    }
  }

  prepopulateData() {
    let fields = [];
    // Mapping of tracking keys to corresponding field codes
    const fieldMapping = {
      'lotChecked': 'lotNo',
      'revisionChecked': 'revisionNo',
      'serializedChecked': 'serialNo',
      'serial2Checked': 'serialNo2',
      'serial3Checked': 'serialNo3',
      'serial4Checked': 'serialNo4',
      'serial5Checked': 'serialNo5',
      'serial6Checked': 'serialNo6',
      'serial7Checked': 'serialNo7',
      'serial8Checked': 'serialNo8',
      'serial9Checked': 'serialNo9',
      'serial10Checked': 'serialNo10',
      'serial11Checked': 'serialNo11',
      'serial12Checked': 'serialNo12',
      'serial13Checked': 'serialNo13',
      'serial14Checked': 'serialNo14',
      'serial15Checked': 'serialNo15',
      'serial16Checked': 'serialNo16',
      'serial17Checked': 'serialNo17',
      'expirationChecked': 'expiration'
    };

    if (!this.importForAllProducts && !this.showWarehouse) {
      // Dynamically check each key and add to fields array
      if (this.selectedAction?.value == 'update' && this.savedData?.length) {
        for (let key of this.optionFields) {
          if (key.checked) {
            fields.push({ code: fieldMapping[key.code], name: key.name });
          }
        }
      }

      for (let key in fieldMapping) {
        if (this.trackingJSON[key] && this.displayName(key, 'label')) {
          const fieldCode = fieldMapping[key];
          const fieldName = this.displayName(key, 'label');

          // Check if the field already exists in the fields array
          const isDuplicate = fields.some(field => field.name === fieldName);
          const isDuplicateOption = this.optionFields.some(field => field.name === fieldName);

          if (!isDuplicate && !isDuplicateOption) {
            fields.push({ code: fieldCode, name: fieldName });
          }
        }
      }
    } else if (this.serialOnly && this.showWarehouse) {
      const secondLastIndex = this.importCols.length - 2;
      this.importCols.splice(secondLastIndex, 1);
      //fields = this.importCols.map(key => key.header);
      fields = this.importCols?.map(col => ({
        code: col.field,
        name: col.header
      }));
    } else if (!this.serialOnly && this.showWarehouse) {
      fields = this.importCols?.map(col => ({
        code: col.field,
        name: col.header
      }));
    } else {
      // Include "ItemNo" and dynamically check other keys
      fields.push({ code: 'ItemNo', name: 'Item Number' });
      for (let key in fieldMapping) {
        if (this.displayName(key, 'label')) {
          fields.push({ code: fieldMapping[key], name: this.displayName(key, 'label') });
        }
      }
    }
    // Define the header row
    const headerRow = fields.map(field => field.name);
    let excelData = [];
    // Convert JSON data to an array format
    if (this.selectedAction?.value == 'update') {
      excelData = this.savedData.map(dt => {
        let obj = {};
        fields.forEach(field => {
          obj[field.name] = dt[field.code] || ''; // Assign field dynamically
        });
        return obj;
      });
    }

    // Create a new workbook and worksheet
    const workbook = new Excel.Workbook();
    const worksheet = workbook.addWorksheet('Sheet 1');

    // Add header row
    const headerROW = worksheet.addRow(headerRow);

    // Apply styling to header row
    headerROW.eachCell((cell: any) => {
      const headerValue = cell._value.model.value;
      const isRequired = this.trackingOptions?.find(el => el.name === headerValue)?.isRequired;

      cell.font = {
        bold: true,
        color: { argb: isRequired || headerValue === 'Item Number' || headerValue === 'ItemNo' ? 'EE0909' : '' } // Red color for required fields or 'Item Number'
      };
    });

    // Add Data Rows
    excelData.forEach(row => {
      worksheet.addRow(headerRow.map(header => row[header])); // Map headers to row values
    });

    // Save the file
    workbook.xlsx.writeBuffer().then(buffer => {
      this.saveAsExcelFile(buffer, 'Tracking.xlsx');
    });
    this.displayOptions = false;
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const downloadLink: any = document.createElement('a');
    downloadLink.href = window.URL.createObjectURL(data);
    downloadLink.download = fileName;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }

  cancelImport() {
    this.cancelClicked.emit({});
  }

  onRemove() {
    this.fields = [];
  }

  onClear() {
    this.fields = [];
  }

  onSelect(event) {
    this.excelFileData = [];
    const file = event.currentFiles[0];
    this.selectedFile = file;
    const fileReader = new FileReader();

    fileReader.readAsArrayBuffer(file);

    fileReader.onload = (e) => {
      const arrayBuffer: any = fileReader.result;
      const data = new Uint8Array(arrayBuffer);
      const arr = new Array();
      for (let i = 0; i < data.length; ++i) {
        arr[i] = String.fromCharCode(data[i]);
      }
      const bstr = arr.join("");
      const workbook: any = read(bstr, { type: "binary" });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];

      // Get the range of the worksheet
      const range = XLSXUtils.decode_range(worksheet['!ref']);

      // Create an array of column indices
      const columns = Array.from({ length: range.e.c - range.s.c + 1 }, (_, i) => range.s.c + i);

      // Use map to iterate over the columns and extract headers
      const headers = columns.map((col, index) => {
        const cellAddress = XLSXUtils.encode_col(col) + '1'; // Reference to column header (first row)
        const cell = worksheet[cellAddress]; // Get the cell object
        const excelColumn = XLSXUtils.encode_col(col);

        return {
          excelHeader: cell && cell.v ? cell.v : `Column (${excelColumn})`,  // The actual value in the cell or empty if undefined
          excelColumn: excelColumn,  // Column reference like A, B, C, etc.
          columnNumber: index + 1,
          moduleField: null
        };
      });
      this.selectedFileHeaders = headers;
    };
  }

  mappingData() {
    this.selectedModule = { id: 0, name: 'Tracking' };
    this.selectedChannel = { id: 0, name: 'Inventory Item' };
    this.disabledMapping = true;
    this.displayFieldMapping = true;
  }

  closMappingModal() {
    this.displayFieldMapping = false;
    this.disabledMapping = false;
  }

  importFileUploaded(data) {
    this.displayFieldMapping = false;
    this.buttonDisabled = true;
    this.selectedRefField = data.referenceId;
    this.mapExcelHeaders(this.selectedFile, data.mappedData);
  }

  async mapExcelHeaders(file: File, headerMapping: any) {
    const workbook = new Excel.Workbook();
    await workbook.xlsx.load(await file.arrayBuffer()); // Load the file
    const worksheet = workbook.worksheets[0]; // Get the first worksheet

    const headerRow = worksheet.getRow(1); // Assuming headers are in the first row

    const previousValues = new Map<number, string>(); // Store previous values by column index
    
    headerRow.eachCell((cell, colNumber) => {
      const currentCellValue = String(cell?.value ?? '').trim();
    
      // Check if this header exists in the mapping
      const matchingHeader = headerMapping.find(h => h.fileHeader.trim() === currentCellValue);
    
      if (matchingHeader) {
        // Update the cell to the mapped label name
        previousValues.set(colNumber, currentCellValue); // optional if you still need this
        cell.value = matchingHeader.labelName;
      } else {
        // Clear cell if it’s not in headerMapping
        cell.value = '';
      }
    });

    headerRow.commit(); // Save the row changes
   
    // Save the updated file
    const buffer = await workbook.xlsx.writeBuffer();
    const updatedFile = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    this.readData(updatedFile);
  }

  readData(file) {
    /**
         * Final Solution For Importing the Excel FILE
         */
    if (typeof Worker !== 'undefined') {
      const worker = new Worker(new URL('../../../../series.worker', import.meta.url));
      worker.onmessage = ({ data }) => {
        if (this.loopColumnWise(data)) {
          this.excelFileData = data;
          this.buttonDisabled = false;
          this.disabledMapping = false;
        } else {
          this.confirmationService.confirm({
            message: this.message,
            header: "Alert Warning",
            icon: "pi pi-info-circle",
            accept: () => {
              this.fileInput.clear();
            },
            reject: () => { },
          });
        }
      }
      const obj = { files: file, params: (this.showWarehouse ? this.serialOnly : this.importForAllProducts), jsonValue: this.trackingJSON, trackingOptions: this.trackingOptions }
      worker.postMessage(obj);
    }
  }


  isNumberOnlyRegex(str: string): boolean {
    return /^\d+$/.test(str);
  }

  isValidSerialNo(str: string): boolean {
    return /^[A-Za-z0-9-]*$/.test(str);
  }

  //run a loop column writeDescription
  loopColumnWise(data) {
    for (let header of this.trackingOptions) {
      const fileHeaderMapped = this.selectedFileHeaders?.some(header => header.moduleField?.label == header.name);
      if (header.enabled && this.trackingJSON[`${header.code}`]) {
        // Iterate over each row
        let index = 0;
        for (let row of data) {
          index++
          const key = `${header.field}`;
          // Skip validation if the row data for the given key is missing or empty
          if (row[key] === null || row[key] === undefined || row[key] === "") {
            continue;
          }
          const formControlName = (header.formControlName == 'InputBox' ? 'string' : header.formControlName);
          const formControlList = ['Number', 'Currency', 'Percentage'];
          if (formControlList.includes(formControlName) && this.isNumberOnlyRegex(row[`${key}`])) {
            row[`${key}`] = Number(row[`${key}`]);
          }
          if (fileHeaderMapped && ((formControlName == 'Decimal' || formControlName == 'Percentage' || formControlName == 'Currency') && (typeof (row[`${key}`]) == 'string' || (row[`${key}`] && typeof (row[`${key}`]) == 'object'))) ||
            (formControlName == 'Number' && row[`${key}`] && (typeof (row[`${key}`]) == 'number' ? (row[`${key}`] != Math.floor(row[`${key}`])) : typeof (row[`${key}`]) != 'number')) ||
            (formControlName == 'string' && (header.code == 'serializedChecked') && !this.isValidSerialNo(row[`${key}`]))) {
            this.message = `Uploded data does not match the DataTypes with <strong>${this.displayName(header.code, 'label')}</strong> config,please upload data in correct format.
              <strong>${this.displayName(header.code, 'label')}</strong> must be of <strong>${formControlName}</strong> type,check rowNo <strong>${index + 1}</strong> from excel file.`
            return false;
          }
        }
      }
    }
    return true;
  }

  checkExtraSerialNOProductWise() {
    if (this.importForAllProducts) {
      for (let prd of this.productList) {
        const itemCount = this.excelFileData?.filter(rcd => rcd.itemNo == prd.itemNo);
        const samePrd = this.productList?.filter(dup => dup.itemNo == prd.itemNo);
        let samePrdCount = 0;
        for (let prd of samePrd) {
          if (this.fromPO) {
            samePrdCount = samePrdCount + (prd.quantity - prd.serialCount)
          } else {
            samePrdCount = samePrdCount + (prd.totalQty - prd.serialCount)
          }
        }
        if (itemCount?.length > samePrdCount) {
          return true;
        }
      }
    } else {
      return false;
    }
  }

  alertDialog() {
    this.confirmationService.confirm({
      message: "You cannot import serial numbers more than ordered qty,Do you still want to proceed?",
      header: "Alert Confirmation",
      icon: "pi pi-info-circle",
      accept: () => {
        if (this.importForAllProducts) {
          const products = [];
          for (let prd of this.productList) {
            const itemCount = this.excelFileData?.filter(data => data.itemNo == prd.itemNo);
            if (itemCount?.length > (this.fromPO ? (prd.quantity - prd.serialCount) : (prd.totalQty - prd.serialCount))) {
              const actualCount = itemCount.splice(0, (this.fromPO ? (prd.quantity - prd.serialCount) : (prd.totalQty - prd.serialCount)));
              for (let product of actualCount) {
                products.push(product)
              }
            } else {
              products.push(itemCount);
            }
          }
          const obj = { excelData: products, rpoId: (this.importForAllProducts && !this.selectedRPO?.isBillCreated ? this.selectedRPO?.id : 0), billOrderId: (this.importForAllProducts && this.selectedRPO?.isBillCreated ? this.selectedRPO?.billOrderId : 0) };
          this.onSave.emit((this.fromPO && this.importForAllProducts) ? obj : products);
        } else {
          this.excelFileData = this.excelFileData.splice(0, this.importCount);
          this.onSave.emit(this.excelFileData);
        }
      },
      reject: () => { },
    });
  }

  checkRequiredValidation() {
    if (this.trackingOptions?.length > 0) {
      for (let opt of this.trackingOptions) {
        const cell = this.getCellByHeader(this.displayName(opt.code, 'label'));
        if (opt.enabled && opt.isRequired && this.trackingJSON[`${opt.code}`] && cell) {
          const propertyData = this.excelFileData?.map(data => data[opt.field]);
          const emptyData = propertyData?.filter(dt => dt == '' || dt == null);
          if (emptyData?.length > 0) {
            return true;
          }
        }
      }
    } else {
      return false;
    }
  }

  save() {
    this.isDisabled = true;
    /**check required validation for imported data **/
    if (!this.checkRequiredValidation()) {
      const cell = this.getCellByHeader(this.displayName('serializedChecked', 'label'));
      if (this.trackingJSON['serializedChecked'] && cell || !this.serialOnly) {
        const seen = new Set();
        let hasDuplicate = false;
        const unique = this.excelFileData?.filter(obj => {
          const serialNo = obj.serialNo != null ? String(obj.serialNo).trim() : ""; // Convert to string safely

          if (serialNo) {
            // Check for duplicates only if serialNo has a value
            if (seen.has(serialNo)) {
              hasDuplicate = true; // Mark that a duplicate exists
            }
            seen.add(serialNo);
          }

          return true; // Keep all values (including blanks)
        });

        if (hasDuplicate) {
          const header = this.displayName((this.serialOnly ? 'serializedChecked' : 'field1'), 'label');
          this.isDisabled = false;
          this.messageService.add({ severity: "error", summary: "Error", detail: `File has duplicate ${header},please check.` });
          return;
        }
       
        const uniqueFieldData = this.excelFileData?.filter((obj, index) => this.excelFileData.findIndex((item) => (item.field1 === obj.field1)) === index);
        const emptySerialNo = this.excelFileData?.filter(item => !item.serialNo);
        const emptyField1 = this.excelFileData?.filter(item => !item.field1);
        const emptyItemNo = this.excelFileData?.filter(item => !item.itemNo);
        if(this.importForAllProducts && emptyItemNo?.length>0){
          this.isDisabled = false;
          this.messageService.add({ severity: "error", summary: "Error", detail: "ItemNo field is missing for some rows,please check." });
          return;
        }
        const obj = { excelData: this.excelFileData, rpoId: (this.importForAllProducts && !this.selectedRPO?.isBillCreated ? this.selectedRPO?.id : 0), billOrderId: (this.importForAllProducts && this.selectedRPO?.isBillCreated ? this.selectedRPO?.billOrderId : 0) }
        const matched = this.excelFileData.filter(item => this.productList.some(_item => _item.itemNo === item.itemNo));
        if (this.showWarehouse && ((this.serialOnly && emptySerialNo?.length > 0) || (!this.serialOnly && emptyField1?.length > 0))) {
          this.messageService.add({ severity: "error", summary: "Error", detail: "No data available to import." });
          this.isDisabled = false;
        } else if (this.importForAllProducts && emptyItemNo?.length==0 &&  matched?.length != this.excelFileData?.length) {
          this.isDisabled = false;
          this.messageService.add({ severity: "error", summary: "Error", detail: "Uploaded file has unmatched itemNo which is not part of the selected order." });
        } else if (this.fromOrder && (this.excelFileData?.length > this.importCount || this.checkExtraSerialNOProductWise()) && this.excelFileData?.length == unique?.length) {
          this.alertDialog();
        } else if (this.fromOrder && this.excelFileData?.length == unique?.length && this.excelFileData?.length <= this.importCount) {
          this.onSave.emit((this.fromPO && this.importForAllProducts) ? obj : this.excelFileData);
        } else if (!this.fromOrder && !this.showWarehouse && this.excelFileData?.length == unique?.length) {
          const obj = { action: this.selectedAction?.value, excelData: this.excelFileData, selectedRPO: this.selectedRPO, rpoId: (this.importForAllProducts && !this.selectedRPO?.isBillCreated ? this.selectedRPO?.id : 0), billOrderId: (this.importForAllProducts && this.selectedRPO?.isBillCreated ? this.selectedRPO?.billOrderId : 0) };
          this.onSave.emit((this.fromPO && this.importForAllProducts) ? obj : { action: this.selectedAction?.value, list: this.excelFileData, referenceId: this.selectedRefField?.code });
        } else if (this.showWarehouse && this.serialOnly && emptyItemNo?.length > 0) {
          this.messageService.add({ severity: "error", summary: "Error", detail: "ItemNo field is missing for some rows,please check." });
        } else if ((this.showWarehouse && this.serialOnly && this.excelFileData?.length == unique?.length) || (!this.serialOnly && !this.displayName('field1', 'duplicate') && this.excelFileData?.length == uniqueFieldData?.length) || (!this.serialOnly && this.displayName('field1', 'duplicate'))) {
          const obj = { excelData: this.excelFileData, selectedLocation: this.selectedLocation, month: this.date?.getMonth(), year: this.date?.getFullYear(), batchId: this.selectedBatch?.id ?? 0, files: this.selectedFile };
          this.onSave.emit(obj);
        } else {
          const header = this.displayName((this.serialOnly ? 'serializedChecked' : 'field1'), 'label');
          this.isDisabled = false;
          this.messageService.add({ severity: "error", summary: "Error", detail: `File has duplicate ${header},please check.` });
        }
      } else {
        if (this.excelFileData?.length <= this.importCount) {
          const obj = { action: this.selectedAction?.value, list: this.excelFileData }
          this.onSave.emit(obj);
        } else {
          this.confirmationService.confirm({
            message: "You cannot import tracking more than QOH,Do you still want to proceed?",
            header: "Alert Confirmation",
            icon: "pi pi-info-circle",
            accept: () => {
              this.excelFileData = this.excelFileData.splice(0, this.importCount);
              const obj = { action: this.selectedAction?.value, list: this.excelFileData, referenceId: this.selectedRefField?.code };
              this.onSave.emit(obj);
            },
            reject: () => { },
          });
        }
      }
    } else {
      this.isDisabled = false;
      this.messageService.add({ severity: "error", summary: "Error", detail: "Please import all the data which is mandatory for tracking." });
    }
  }


  //scan Items
  countNameList(value) {
    if (this.trackingForm.valid && this.listLength < this.importCount) {
      const duplicate = this.autoGenerateLists?.filter((sr) => sr.serialNo == value.serialNo);
      if (duplicate?.length > 0) {
        this.messageService.add({
          severity: "error",
          summary: "Error",
          detail: "Serial No you tried to enter is already present in below list.",
        });
      } else {
        const present = this.systemTrackingData?.find((depOb) => depOb.serialNo == value.serialNo);
        if (present) {
          value.systemPresent = true;
          value.checked = false;
          value.itemNo = present.itemNo;
          value.productId = present.productId;
          this.autoGenerateLists.push(value);
          this.nameLists = this.autoGenerateLists.slice(0, 100);
          this.listLength = this.listLength + 1;
          this.totalTBRecord = this.listLength;
        } else {
          const productsIds = [];
          this.productList?.forEach((element) => {
            productsIds.push(element.product?.id);
          });
          const ids = productsIds.join(",");
          this.checkSerialsForSystem(this.trackingForm.controls["serialNo"].value, ids, this.warehouseId, this.creditMemoId, value);
        }
      }
    }
    this.trackingForm.controls["serialNo"].setValue("");
  }

  checkSerialsForSystem(serialNo, productIds, warehouseId, cmId, value) {
    this.serialService.checkSerialNoInSystem(serialNo, warehouseId, productIds, cmId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe((res) => {
      if (!this.serialConfig?.childInventorySettings[0]?.enabled) {
        if (res.allowSave) {
          value.systemPresent = false;
          value.checked = true;
          this.autoGenerateLists.push(value);
          this.nameLists = this.autoGenerateLists.slice(0, 100);
          this.listLength = this.listLength + 1;
          this.totalTBRecord = this.listLength;
        } else if (!res.allowSave || !res.isMatched) {
          this.messageService.add({ severity: "error", summary: "Error", detail: `${res.message}` });
        } else {
          this.messageService.add({ severity: "error", summary: "Error", detail: "SerialNo you tried to import is not a part of this order and associated with other product,you can't add." });
        }
      } else {
        //auto-remove unmatched while save button
        value.systemPresent = false;
        value.checked = true;
        value.remove = true;
        this.autoGenerateLists.push(value);
        this.nameLists = this.autoGenerateLists.slice(0, 100);
        this.listLength = this.listLength + 1;
        this.totalTBRecord = this.listLength;
      }
    });
  }

  removeNumber(i) {
    this.nameLists.splice(i, 1);
    this.autoGenerateLists.splice(i, 1);
    this.nameLists = this.autoGenerateLists.slice(0, 100);
    this.listLength--;
    this.totalTBRecord = this.listLength;
  }

  deleteAll() {
    this.nameLists = [];
    this.autoGenerateLists = [];
    this.listLength = 0;
    this.totalTBRecord = 0;
  }

  loadSerialsLazy(event) {
    if (this.autoGenerateLists) {
      this.nameLists = this.autoGenerateLists.slice(event.first, event.first + event.rows);
    }
  }

  setTableCheck() {
    for (let s of this.autoGenerateLists) {
      if (this.allChecked) {
        s.checked = true;
      } else {
        s.checked = false;
      }
    }
  }

  setMainHeaderTracking() {
    const checked = this.nameLists.filter((ch) => ch.checked);
    if (checked.length == this.nameLists?.length) {
      this.allChecked = true;
    } else {
      this.allChecked = false;
    }
  }

  replaceCommaLine(data) {
    let dataToArray = data.split(",").map((item) => item.trim());
    return dataToArray;
  }

  scanSerials() {
    if (this.serialConfig?.childInventorySettings[0]?.enabled) {
      const arrayList = JSON.parse(JSON.stringify(this.autoGenerateLists));
      for (let serial of arrayList) {
        if (serial.remove) {
          const index = this.autoGenerateLists?.indexOf(serial);
          this.autoGenerateLists.splice(index, 1);
        }
      }
    }
    this.onScan.emit(this.autoGenerateLists);
  }

  isNumberKey(evt) {
    const charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
    return true;
  }

  onDateSelect(event: Date): void {
    const options: any = { year: 'numeric', month: 'long' };
    this.formattedDate = event.toLocaleDateString('en-US', options);
  }

  onRevert() {
    this.messageService.add({ severity: "success", summary: "Success", detail: `Import data rollback successfully.` });
    this.onRevertSuccess.emit();
  }


  ngOnDestroy(): void {
    if (this.ngUnsubscribe$) {
      this.ngUnsubscribe$.next();
      this.ngUnsubscribe$.complete();
      this.ngUnsubscribe$.unsubscribe();
    }
  }

}
